export default __webpack_public_path__ + "static/media/goshen95.a79aa684.jpg";